import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { cardSettingsFormSchema, Sizes } from "./constants";
import { AdvancedCardProps, cardSettingsType } from "./types";

export const details = {
  name: "AdvancedCard",
  description: "A card with advanced features",
  tags: ["Data"],
  category: "Advanced",
  grid: Sizes,
  setup: lazy(() => import("./Setup").then(m => ({ default: m.Setup }))),
  context: lazy(() => import("./Context").then(m => ({ default: m.Context }))),
  defaultProps: {
    mapping: {
      requestId: "",
      ...cardSettingsFormSchema.parse({
        title: "Custom Card",
        deepKey: "",
        valueTransformation: "",
      } as cardSettingsType),
    },
  },
} as ElementDetails<AdvancedCardProps>;
